import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($email: String, $phone: String, $password: String!) {
    login(email: $email, phone: $phone, password: $password) {
      token
      user {
        id
        email
        phone
        role
        isActive
      }
    }
  }
`;

export const REGISTER_MUTATION = gql`
  mutation Register($email: String, $phone: String, $password: String!, $role: String, $personId: Int) {
    register(input: { email: $email, phone: $phone, password: $password, role: $role, personId: $personId }) {
      token
      user {
        id
        email
        phone
        role
        isActive
      }
    }
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($userId: ID!, $oldPassword: String!, $newPassword: String!) {
    changePassword(userId: $userId, oldPassword: $oldPassword, newPassword: $newPassword)
  }
`;

export const GET_USER_QUERY = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      id
      email
      phone
      role
      personId
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const GET_USER_BY_EMAIL_QUERY = gql`
  query GetUserByEmail($email: String!) {
    userByEmail(email: $email) {
      id
      email
      phone
      role
      personId
      isActive
      createdAt
      updatedAt
    }
  }
`;